<template>
  <DashboardTemplate>
    <div class="pd-b-4 border-b">
      <p class="text-right mg-y-less color-gray-lighter cursor-pointer">
        <i
          @click="
            $router.push(
              `/discussion/forum?courseId=${course._id}&subjectId=${subject._id}`
            )
          "
          class="fas fa-times"
        ></i>
      </p>
      <h3 class="text-left text-font-24 mg-y-less">
        เพิ่มกระดานถาม - ตอบระหว่างเรียน (Discussion Forum)
      </h3>
    </div>
    <div class="text-left pd-t-4">
      <p class="text-font-14">
        ชื่อหลักสูตร:
        <span class="color-gray">{{ course.name }}</span
        ><span class="pd-l-4">วิชาที่: </span>
        <span class="color-gray">{{ subject.name }}</span>
      </p>
      <DiscussionForumForm 
        v-if="subject"
        @createDiscussionForum="createDiscussionForum" />
    </div>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import DiscussionForumForm from "@/components/discussionForum/DiscussionForumForm";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    DiscussionForumForm,
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
    courseList() {
      return this.$store.state.courseList;
    },
  },
  data() {
    return {
      form: {
        name: "",
        distanceDate: "",
        description: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "กรุณากรอกชื่อหัวข้อ",
            trigger: "blur",
          },
        ],
        distanceDate: [
          {
            required: true,
            message: "กรุณาเลือกระยะเวลาในการเปิด-ปิด",
            trigger: "change",
          },
        ],
        description: [
          {
            required: true,
            message: "กรุณากรอกรายละเอียด",
            trigger: "blur",
          },
        ],
      },
      course: "",
      subject: "",
    };
  },
  mounted() {
    this.setCourse();
  },
  methods: {
    setCourse() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);

      let filter = this.courseList.filter(
        (filter) => filter._id == this.$route.query.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.$route.query.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    createDiscussionForum(data) {
      this.loadingDialog = true;

      let obj = {
        type: "discussion",
        courseId: this.$route.query.courseId,
        subjectId: this.$route.query.subjectId,
        title: data.name,
        durationTime: {
          open: data.distanceDate[0],
          close: data.distanceDate[1],
        },
        description: data.description,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`take`, obj)
        .then((res) => {
          if (res.data.success) {
            this.$router.push(
              `/discussion/forum?courseId=${this.$route.query.courseId}&subjectId=${this.$route.query.subjectId}`
            );
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("createDiscussionForum error", e);
        })
        .finally(() => {
          this.loadingDialog = false;
        });
    },
  },
};
</script>
